/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateNonConformance } from '../../models/create-non-conformance';

export interface GetNonConformance2$Params {
  productionOrderId?: number;
}

export function getNonConformance2(http: HttpClient, rootUrl: string, params?: GetNonConformance2$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateNonConformance>> {
  const rb = new RequestBuilder(rootUrl, getNonConformance2.PATH, 'get');
  if (params) {
    rb.query('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateNonConformance>;
    })
  );
}

getNonConformance2.PATH = '/api/v1/QualityHistory/GetCreateNonConformance';
